import type { DateWithFallback } from '../../Util/DateHandling.js'
import { formatDate, parseDate } from '../../Util/DateHandling.js'
import { useEffect, useState } from 'react'
import { TooltipTrigger } from '../../Provider/TooltipManager.js'

export type DateWidgetProps = {
  date: string
}

export const DateWidget = (props: DateWidgetProps) => {
  const [parsedTime, setParsedTime] = useState<DateWithFallback>('')

  useEffect(() => {
    setParsedTime(parseDate(props.date))
  }, [props.date])

  return (
    <TooltipTrigger tooltip={props.date}>
      {formatDate(parsedTime)}
    </TooltipTrigger>
  )
}
